import { commonTranslationKeys } from '@dreryk/react-common';
import { ActionBar } from '@dreryk/react-components';

import { HealthcarePracticeFormBean } from '../common/healthcarePractice';

import { HealthcarePracticeUpdateForm } from './HealthcarePracticeUpdateForm';

type HealthcarePracticeUpdatePanelProps = {
   readonly healthcarePractice: HealthcarePracticeFormBean;
   readonly onEditEnd: () => void;
   readonly onDataChanged: () => Promise<void>;
   readonly verifyAccountConfiguration: () => Promise<void>;
};

export const HealthcarePracticeUpdatePanel = (props: HealthcarePracticeUpdatePanelProps): JSX.Element => {
   return (
      <>
         <HealthcarePracticeUpdateForm
            healthcarePractice={props.healthcarePractice}
            onDataChanged={props.onDataChanged}
            verifyAccountConfiguration={props.verifyAccountConfiguration}
         />
         <ActionBar.PrimaryLink
            testId='practiceDataUpdateCancel'
            label={commonTranslationKeys.cancel}
            onClick={props.onEditEnd}
         />
      </>
   );
};
